export default __webpack_public_path__ + "static/media/google-upload-3.284c5e58.jpeg";